import createReactComponent from '../createReactComponent';
var Italic = createReactComponent('Italic', [['line', {
  x1: '19',
  y1: '4',
  x2: '10',
  y2: '4',
  key: 'ohvhe'
}], ['line', {
  x1: '14',
  y1: '20',
  x2: '5',
  y2: '20',
  key: 'pl6qj'
}], ['line', {
  x1: '15',
  y1: '4',
  x2: '9',
  y2: '20',
  key: 'baf5vk'
}]]);
export default Italic;